import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import TicketList from './TicketList';
import HeaderCard from '../Common/HeaderCard';
import { Apps, SupportTicket, TicketListhead, TicketListspan } from '../../Constant';
import { Breadcrumbs } from '../../AbstractElements';
import TicketTableWrapper from './TicketTableWrapper';

const SupportTicketContain = () => {
  return (
    <Container fluid={true} className='support-ticket'>
      <Breadcrumbs pageTitle={SupportTicket} parent={Apps} title={SupportTicket} />
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title={TicketListhead} span1={TicketListspan} />
            <CardBody>
              <TicketList />
              <TicketTableWrapper />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default SupportTicketContain;
